import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD4VAejd2YNPym7BfLQxu30ZtQpXViDoJk",
  authDomain: "cayc-incubator.firebaseapp.com",
  projectId: "cayc-incubator",
  storageBucket: "cayc-incubator.firebasestorage.app",
  messagingSenderId: "1094574936884",
  appId: "1:1094574936884:web:22985defe5b696429c4b61",
  measurementId: "G-N6HMKK4K92"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);